import { VueModule } from "@Foundation/utilities";
import RadioSelection from './code/Scripts/components/radio-selection';

export default VueModule({
    components: {
        RadioSelection
    }
})